import imaginationPoster from '@/assets/imagination-poster.png';
import imaginationVideo from '@/assets/videos/exercises/imagination/imagination.webm';
import ImaginationFlow from '@/components/Exercises/Breathing/ImaginationFlow';
import { Button } from '@/components/ui/button';
import { ExerciseLayout } from '@/components/ui/exercise-layout';
import SubtitleLanguageSwitcher from '@/components/ui/SubtitleLanguageSwitcher';
import VideoWithSubtitles, { type VideoWithSubtitlesRef } from '@/components/ui/VideoWithSubtitles';
import { useLocale } from '@/contexts/IntlContext';
import { createFileRoute } from '@tanstack/react-router';
import { useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';

export const Route = createFileRoute(
  '/(content)/adults/exercises/(shared)/imagination/exercise',
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    referrer: search?.referrer as string | undefined,
  }),
  beforeLoad: () => ({
    title: "imagination.title",
    navbar: {
      showTitle: true,
    }
  }),
})

function RouteComponent() {
  const [showOverlay, setShowOverlay] = useState(false);
  const videoRef = useRef<VideoWithSubtitlesRef>(null);
  const { locale } = useLocale();
  const [subtitleLanguage, setSubtitleLanguage] = useState<"ar" | "en">(locale);

  const subtitleTracks = [
    {
      src: "/subs/imagination.ar.vtt",
      srcLang: "ar",
      label: "العربية",
      default: subtitleLanguage === "ar"
    },
    {
      src: "/subs/imagination.en.vtt",
      srcLang: "en",
      label: "English",
      default: subtitleLanguage === "en"
    }
  ];

  const startExercise = () => {
    setShowOverlay(true);
    videoRef.current?.video?.pause();
  };

  const closeOverlay = () => {
    setShowOverlay(false);
    videoRef.current?.resetVideo();
  };

  return (
    <>
      {showOverlay ? (
        <ImaginationFlow onClose={closeOverlay} isShow={showOverlay} />
      ) : (
        <ExerciseLayout
          contentClassName="py-7.5 space-y-18"
          actions={
            <Button className="w-full" onClick={startExercise}>
              <FormattedMessage id="breathing.startExercise" />
            </Button>
          }
        >
          <div className="space-y-2.5">
            <div>
              <h3 className="text-h3 font-medium text-black ">
                <FormattedMessage id="breathing.intro.title" />
              </h3>
              <p className="text-small text-black ">
                <FormattedMessage id="imagination.intro.subtitle" />
              </p>
            </div>

            <SubtitleLanguageSwitcher
              subtitleLanguage={subtitleLanguage}
              onLanguageChange={setSubtitleLanguage}
            />

            <VideoWithSubtitles
              ref={videoRef}
              src={imaginationVideo}
              poster={imaginationPoster}
              subtitleTracks={subtitleTracks}
              activeSubtitleLanguage={subtitleLanguage}
              loop={false}
            />
          </div>
        </ExerciseLayout>
      )}
    </>
  );
}
